import React from "react"
const RenderFormatteContent = (content: string) => {
    const paragraphs = content?.split('\n');
    return paragraphs?.map((paragraph, index) => (
        <p key={index} className={index === paragraphs?.length - 1 ? 'mb-0' : ''}>{paragraph}</p>
    ));
}
export default RenderFormatteContent